import connect from 'components/Shared/connect';
import {
  getBrandContent,
  getHeader,
  getDescription,
  getSeoBlock,
  getSliderAds,
  getProductListType
} from 'views/ProductlistPage/selectors';
import { NO_ELEMENT, hasElements } from 'utils';
import { isMobile, isTablet } from 'components/Shared/responsive';
import { ReactComponent } from 'models/ReactComponent';
import { BrandDescription } from 'views/ProductlistPage/themes/BGH/brandContent/brandDescription';
import { PopularCategories } from './popularCategories';
import { ImageGallery } from './imageGallery';
import { ProductListType } from 'models/ProductListType';
import { VideoGallery } from './videoGallery';
import { ImageLinks } from './imageLinks';
import { ProductlistPageBrandContent } from 'models/ProductlistPageBrandContent';
import Image from 'components/Shared/Image';
import { SliderAd } from 'models/SliderAd';
import { Section } from 'components/Section';
import styles from './brandContentTop.scss';

interface OwnProps {
  brandContent: ProductlistPageBrandContent;
  header: string;
}
interface MergedProps extends OwnProps {
  description: string;
  seoBlock?: ReactComponent;
}

const BrandPageBrandContent = connect<MergedProps, OwnProps>(state => ({
  description: getDescription(state.currentPage),
  seoBlock: getSeoBlock(state.currentPage),
  isMobile: isMobile(state)
}))(({ brandContent, header, description, seoBlock }: MergedProps) => {
  const { popularCategories, mainImage, brandName, brandLogo, images, videos, imageLinks } =
    brandContent;

  return (
    <>
      <BrandDescription
        mainImage={mainImage}
        header={header}
        description={description}
        seoBlock={seoBlock}
        brandLogo={brandLogo}
      />
      {hasElements(popularCategories) && (
        <PopularCategories popularCategories={popularCategories} brandName={brandName} />
      )}
      {hasElements(images) && <ImageGallery images={images} />}
      {hasElements(videos) && <VideoGallery videos={videos} />}
      {hasElements(imageLinks) && <ImageLinks imageLinks={imageLinks} />}
    </>
  );
});

const PANORAMA_DIMENSIONS = {
  width: 1472,
  height: 605
};

interface BrandFIlterCategoryBrandContentMergedProps extends OwnProps {
  sliderAds?: SliderAd[];
  isMobile: boolean;
}

const BrandFilterCategoryBrandContent = connect<
  BrandFIlterCategoryBrandContentMergedProps,
  OwnProps
>(state => ({
  sliderAds: getSliderAds(state.currentPage),
  isMobile: isMobile(state)
}))(function BrandContent({ isMobile, ...props }: BrandFIlterCategoryBrandContentMergedProps) {
  const panorama = hasElements(props.sliderAds) ? props.sliderAds[0] : undefined;

  const headerTitle = <h1>{props.header}</h1>;
  return (
    <>
      <Section title={isMobile ? undefined : headerTitle}>
        {panorama && (
          <Image
            className={styles.panorama}
            wrapperStyle={{ marginBottom: 10 }}
            paddingBottom
            {...PANORAMA_DIMENSIONS}
            {...panorama.adImage}
          />
        )}
      </Section>
    </>
  );
});

interface BrandProps {
  type: ProductListType;
  brandContent: ProductlistPageBrandContent | undefined;
  header: string;
  brandName: string | undefined;
  isMobile: boolean;
  isTablet: boolean;
}

export const BrandContentTop = connect(state => ({
  type: getProductListType(state),
  brandContent: getBrandContent(state.currentPage),
  header: getHeader(state),
  isMobile: isMobile(state),
  isTablet: isTablet(state)
}))(({ brandContent, type, header, isMobile, isTablet }: BrandProps) => {
  if (brandContent === undefined || type === ProductListType.CategoryFilter) {
    if (isMobile || isTablet) {
      return NO_ELEMENT;
    }

    return <Section title={header}></Section>;
  }

  if (type === ProductListType.Brand) {
    return <BrandPageBrandContent brandContent={brandContent} header={header} />;
  }

  if (type === ProductListType.BrandCategoryFilter) {
    return <BrandFilterCategoryBrandContent brandContent={brandContent} header={header} />;
  }

  return NO_ELEMENT;
});
